module.exports = __webpack_public_path__ + "img/sv6.a1a37731.svg";